import { create } from "zustand";
import { vayuCall, vayuLead } from "../api_layer/api";

export const useVayuLead = create((set) => ({
  vayuLeadData: [],
  leadLoading: false,
  isError: false,
  fetchVayuLead: async (page, query) => {
    set({ leadLoading: true, isError: false });
    try {
      const response = await vayuLead(page, query);
      set({ vayuLeadData: response.data, leadLoading: false });
    } catch (error) {
      set({ isError: true, data: [], leadLoading: false });
    }
  },
  vayuLeadCall: async (payload, setToaster) => {
    try {
       await vayuCall(payload);
       setToaster("Call", "Call Connecting", "success")
    } catch (error) {
      setToaster("Call", error?.response?.data?.message|| "Call failed", "danger");
    }
  },
}));
